import React from 'react';
import { Calendar, MessageSquare, Share2, Globe, Users, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card } from '../UI';

export const FeaturesOffice: React.FC = () => {
  const { t } = useTranslation(['office']);

  const features = [
    {
      icon: Calendar,
      title: t('office:features.appointmentsCard.title'),
      description: t('office:features.appointmentsCard.desc'),
    },
    {
      icon: MessageSquare,
      title: t('office:features.crmCard.title'),
      description: t('office:features.crmCard.desc'),
    },
    {
      icon: Share2,
      title: t('office:features.marketingCard.title'),
      description: t('office:features.marketingCard.desc'),
    },
    {
      icon: Globe,
      title: t('office:features.websiteCard.title'),
      description: t('office:features.websiteCard.desc'),
    },
    {
      icon: Users,
      title: t('office:features.recruitmentCard.title'),
      description: t('office:features.recruitmentCard.desc'),
    },
    {
      icon: Star,
      title: t('office:features.reviewsCard.title'),
      description: t('office:features.reviewsCard.desc'),
      multiStar: true,
    },
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t('office:features.sectionTitle')}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {t('office:features.sectionSubtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} hover className="text-center">
              <div className="flex flex-col items-center">
                <div className="mb-4 p-4 bg-blue-100 dark:bg-blue-900/30 rounded-full">
                  <feature.icon className="h-8 w-8 text-blue-600 dark:text-blue-400" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

